import { SxProps, Theme } from "@mui/material";

export const dialogPaperSx = (theme: Theme): SxProps<Theme> => ({
  borderRadius: 2,
  backgroundColor: theme.palette.background.paper,
  padding: 0,
});

export const dialogContentSx: SxProps<Theme> = {
  padding: 3,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const titleSx = (theme: Theme): SxProps<Theme> => ({
  textAlign: "center",
  mb: 1,
  fontSize: 18,
  fontWeight: 600,
  color: theme.palette.text.primary,
});

export const buttonsContainerSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  mt: 2,
};

export const goButtonSx: SxProps<Theme> = {
  py: 1.5,
  fontSize: 16,
  fontWeight: 600,
  backgroundColor: "#06B6D4",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#0891b2",
    color: "#FFFFFF",
  },
  "&:disabled": {
    backgroundColor: "#06B6D4",
    color: "#FFFFFF",
    opacity: 0.6,
  },
};

export const audioOnlyButtonSx: SxProps<Theme> = {
  py: 1.5,
  fontSize: 16,
  fontWeight: 600,
  backgroundColor: "transparent",
  border: "1px solid rgba(6, 182, 212, 0.6)",
  color: "#06B6D4",
  "&:hover": {
    backgroundColor: "rgba(6, 182, 212, 0.08)",
    border: "1px solid rgba(6, 182, 212, 0.9)",
  },
  "&:disabled": {
    border: "1px solid rgba(6, 182, 212, 0.3)",
    color: "#06B6D4",
    opacity: 0.6,
  },
};
